import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule} from '@angular/common/http';
import { AppService } from './app.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { BandeauComponent } from './bandeau/bandeau.component';
import { PrincipalComponent } from './principal/principal.component';
import { CoteComponent } from './cote/cote.component';
import { PiedComponent } from './pied/pied.component';
import { AccueilComponent } from './principal/accueil/accueil.component';
import { AppRoutingModule } from './app-routing.module';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InterventionsComponent } from './principal/interventions/interventions.component';
import { ListeRuchersComponent } from './principal/interventions/liste-ruchers/liste-ruchers.component';
import { InterventionComponent } from './principal/interventions/intervention/intervention.component';
import { NgbdDatepickerI18n } from './outils/datepicker-I18n';
import { ListeInterventionsComponent } from './principal/interventions/liste-interventions/liste-interventions.component';
import { WriteInterventionModalComponent } from './principal/interventions/write-intervention-modal/write-intervention-modal.component';
import { DetailInterventionComponent } from './principal/interventions/detail-intervention/detail-intervention.component';
import { OnlyNumbersDirective } from './outils/only-numbers.directive';
import { TitleCasePipe } from '@angular/common';
import { DefilementDirective } from './outils/defilement.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [
    AppComponent,
    BandeauComponent,
    PrincipalComponent,
    CoteComponent,
    PiedComponent,
    AccueilComponent,
    ErrorModalComponent,
    InterventionsComponent,
    ListeRuchersComponent,
    InterventionComponent,
    NgbdDatepickerI18n,
    ListeInterventionsComponent,
    WriteInterventionModalComponent,
    DetailInterventionComponent,
    OnlyNumbersDirective,
    DefilementDirective
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    BrowserAnimationsModule,
    NgbModule.forRoot()
  ],
  exports: [],
  providers: [AppService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts